// .u_program-references
class UProgramReferences extends Uneet {
  constructor(domElement) {
    super(domElement)
    this.__init()
  }

  __init() {
    jQuery(this._e).find('.content').hide()

    this._e.querySelector('.title').addEventListener('click', () => {
      jQuery(this._e).toggleClass('isOpen').find('.content').slideToggle('fast')
    })
  }
}

